export default __webpack_public_path__ + "static/media/donut.1a639273.svg";